import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveGanttCalendarRangeRequestFailure(zone) {
      const req = getState().find(
        (req) =>
          (typeof req.zone === "undefined" && typeof zone === "undefined") ||
          req.zone?.uuid === zone?.uuid,
      );

      return req ? req.request.isFailure : false;
    },
    isRetrieveGanttCalendarRangeRequestPending(zone) {
      const req = getState().find(
        (req) =>
          (typeof req.zone === "undefined" && typeof zone === "undefined") ||
          req.zone?.uuid === zone?.uuid,
      );

      return req ? req.request.isPending : false;
    },
    isRetrieveGanttCalendarRangeRequestSuccess(zone) {
      const req = getState().find(
        (req) =>
          (typeof req.zone === "undefined" && typeof zone === "undefined") ||
          req.zone?.uuid === zone?.uuid,
      );

      return req ? req.request.isSuccessful : false;
    },
    getGanttCalendarRange(zone) {
      const req = getState().find(
        (req) =>
          (typeof req.zone === "undefined" && typeof zone === "undefined") ||
          req.zone?.uuid === zone?.uuid,
      );

      return req ? req.range : ["", ""];
    },
  };
}

export { createSelector };
